import { SVGAttributes } from "react";

export const MergeIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" }
) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.707 7.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 111.414-1.414l3 3z"
        fill="currentColor"
      />
      <path
        d="M13.293 7.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414-1.414l3-3z"
        fill="currentColor"
      />
      <path
        d="M2 3a1 1 0 010-2h2c.516 0 1.22.117 1.947.48C7.212 2.114 8 3.296 8 5c0 .92.337 1.426.947 1.73.399.2.82.27 1.053.27h3a1 1 0 110 2h-3c-.516 0-1.22-.117-1.947-.48C6.788 7.886 6 6.704 6 5c0-.92-.337-1.426-.947-1.73C4.654 3.07 4.233 3 4 3H2z"
        fill="currentColor"
      />
      <path
        d="M2 15a1 1 0 110-2h2c.234 0 .654-.07 1.053-.27.61-.304.947-.81.947-1.73 0-1.705.788-2.887 2.053-3.52A4.441 4.441 0 0110 7h3a1 1 0 110 2h-3c-.234 0-.654.07-1.053.27C8.337 9.573 8 10.08 8 11c0 1.705-.788 2.887-2.053 3.52A4.44 4.44 0 014 15H2z"
        fill="currentColor"
      />
    </svg>
  );
};
MergeIcon.displayName = "MergeIcon";
